"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumAuthoriserData = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "TealiumAuthoriserData", { enumerable: true, get: function () { return features_1.TealiumAuthoriserData; } });
//# sourceMappingURL=index.js.map